import { z } from "zod";
import { AUDIT_ACTIONS, AUDIT_ENTITIES } from "@fysaro/types";

export const createAuditLogSchema = z.object({
  entity: z.enum(Object.values(AUDIT_ENTITIES) as [string, ...string[]]),
  entityId: z.string().uuid(),
  action: z.enum(Object.values(AUDIT_ACTIONS) as [string, ...string[]]),
  userId: z.string().uuid().nullable().optional(),
  ip: z.string().nullable().optional(),
  metadata: z.record(z.string(), z.any()).nullable().optional(),
}).strict();

export const updateAuditLogSchema = z.object({
  metadata: z.record(z.string(), z.any()).nullable().optional(),
}).strict();
